import angular from 'angular';
import { CandidateProfileStatusLabelConfiguration } from './component';

const MODULE_NAME = 'TALENYA-FE';

angular
    .module(MODULE_NAME)
    .component('candidateProfileStatusLabel', CandidateProfileStatusLabelConfiguration);

export default MODULE_NAME;